import { default as styled } from 'styled-components';
import { default as Progress } from '@clds/progress';

export const ProgressSpinner = styled(Progress.Logo)`
  width: 15%;
  max-width: 130px;
  position: absolute;
  inset: 0;
  margin: auto;
`;

const SpinnerWrapper = styled.div`
  position: relative;
  display: flex;
  height: 100%;
`;

export const FullScreenSpinner = () => (
  <SpinnerWrapper>
    <ProgressSpinner size="md" />
  </SpinnerWrapper>
);
